import {
    SubscriptionPlanSubscriberState,
    SubscriptionPlanProductType,
} from '@udemy/subscription-graphql';

export const isSubscriberToAnyGwgPlan = (
    currentlySubscribedPlan: SubscriptionPlanSubscriberState,
) => {
    return (
        currentlySubscribedPlan?.productType === SubscriptionPlanProductType.GrowWithGoogle ||
        currentlySubscribedPlan?.productType ===
            SubscriptionPlanProductType.ConsumersubscriptionPlusGrowWithGoogle
    );
};
